module.exports = __webpack_public_path__ + "static/media/classroom.2d87fd2e.jpg";